import React from 'react'
import {realPath} from '../lib/util'
import DocViewer from '../lib/DocViewer'

const known_types = ['pdf', 'doc', 'docx', 'xls', 'xlsx']
const img_types = ['jpg', 'png', 'gif']

class Doc extends React.Component {
	state = {
		docIndex: 0,
		//i: 0,
		//loaded: false
	}
	/*
	componentWillMount = () => {
		this.ri = setInterval(() => {this.reloadDoc()}, 3000)
	}
	componentWillReceiveProps = nextProps => {
		if(this.ri) clearInterval(this.ri)
		this.ri = setInterval(() => {this.reloadDoc()}, 3000)
		this.setState({i: this.state.i+1, loaded: false})
	}
	componentWillUnmount = () => {
		if(this.ri) clearInterval(this.ri)
		this.ri = null
	}
	*/
	handleDocSelect = e => {
		const docIndex = parseInt(e.currentTarget.getAttribute('data-doc'), 10)
		this.setState({docIndex})
	}
	render() {
		const {docs} = this.props
		const {docIndex} = this.state
		
		if(!docs || docs.length===0) return <div/>
		
		let fileType = null
		if(docs && docs.length>0) fileType = docs[docIndex].url.split('.').pop().toLowerCase()

		return (
			<div className='field-docs'>
				<div className='header'>
					{docs && docs.length>1 && <div>
					<div className='label'>Documente: </div>
					<div className='dropdown'>
						<span>{docs[docIndex].name}</span>
						<div className="dropdown-content">
    						{docs.map((f, j) => 
    								<p key={j} data-doc={j} 
    									className={(docIndex===j)?'selected':''}
    									onClick={this.handleDocSelect}>{f.name}</p>
    						)}
  						</div>
					</div> </div> 
					}
					{docs && <a href={realPath(docs[docIndex].url)} className='download'><i className='fa fa-download fa-2x'></i></a>}
				</div>
							
				{known_types.includes(fileType) &&
					<DocViewer url={docs[docIndex].url} classes='embed-paper'/>
				}
				{img_types.includes(fileType) &&
					<div className='img-doc'><div className='content'>
						<img src={realPath(docs[docIndex].url)} alt='doc' style={{display: 'block', margin: '20px auto'}}/>
					</div></div>
				}
			</div>
		)
	}
}
export default Doc



// WEBPACK FOOTER //
// ./src/fm/field/Doc.js